export default "__VITE_ASSET__Cb_d2ifC__"